import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ResultpageService } from '../../../service/resultpage.service';

@Component({
  selector: 'app-filter-barplot-range',
  templateUrl: './filter-barplot-range.component.html',
  styleUrls: ['./filter-barplot-range.component.scss'],
})
export class FilterBarplotRangeComponent implements OnInit {
  @Input() rateData!: any;
  @Input() key!: any;

  @Output() rangeOutput = new EventEmitter<any>();

  public oneAmount!: boolean;
  public selectRangeProgress!: number;
  public disabled: boolean = true;
  private checkedValue!: number;

  constructor() {}

  ngOnInit(): void {}

  detectRange(value: any): void {
    this.checkedValue = value;
    this.oneAmount = this.rateData.length === 1;
    this.rateData.selectRangeProgress =
      this.checkedValue !== 0 && !this.oneAmount
        ? ((value - this.rateData.amountMin) * 100) /
          (this.rateData.amountMax - this.rateData.amountMin)
        : 0;
    let obj: any = {
      value: Number(value),
      key: this.key,
    };
    this.rangeOutput.emit(obj);
  }

  trackByBarValue(index: number, bar: { value?: number }): number {
    return bar?.value ?? index;
  }
}
